import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M17 5l-8 8-8-8v1.6l8 8 8-8z" />
  </svg>
);

export default SvgComponent;
